// BAC Offered? - shared between the add and edit exam panes so the option lists and
// the required-field rule can't drift apart.

// Screening mammogram. BAC is only asked on this category.
export const SCRMAM_CATEGORY_ID = '4d172b6f-936c-422c-9a81-de5befaa3ef7';

// The facility must be mapped to this category to offer BAC at all - the field is hidden
// where it is not, because an exam created there renders with a blank exam type.
export const BAC_CATEGORY_ID = 'd4dbb36f-f031-43e5-a8fa-eeb7db7b0008';

// Selecting "Accepted" spawns an exam of this type on the same date/time.
export const BAC_EXAM_TYPE_ID = '667567ba-53e9-4caf-8bd7-c18b8fe43212';

/**
 * Returns '' when the BAC answers are complete for the given form state, otherwise the
 * reason they are not.
 *
 * statusRequired is false when editing an exam that predates this feature - those have no
 * answer and must stay saveable, but if the user does pick a status the dependent fields
 * still have to be filled in.
 */
export function bacValidationError(formFields, isScreeningMammo, statusRequired = true, reasons) {
    if (!isScreeningMammo) return '';
    if (!formFields.bacOfferedStatus) return statusRequired ? 'BAC Offered? is required.' : '';

    if (formFields.bacOfferedStatus === 'Declined' || formFields.bacOfferedStatus === 'NotOffered') {
        if (!formFields.bacDetail) {
            return formFields.bacOfferedStatus === 'Declined'
                ? 'Decline Details is required.'
                : 'Offer Details is required.';
        }
        if (bacDetailRequiresNotes(formFields.bacDetail, reasons) && !(formFields.bacNotes || '').trim()) {
            return `Notes are required when ${formFields.bacDetail} is selected.`;
        }
    }

    return '';
}

/**
 * Does the selected reason require a note?
 *
 * Driven by the reason's requiresNotes flag rather than matching the label against 'Other'.
 * The lists are admin-editable, so a name match breaks the moment a reason is renamed or a
 * second note-requiring reason is added.
 *
 * Falls back to the 'Other' match only when no reasons were supplied, so the exam form still
 * behaves if the list fails to load - better than quietly deciding nothing needs a note.
 */
export function bacDetailRequiresNotes(bacDetail, reasons) {
    if (!bacDetail) return false;
    if (!reasons || reasons.length === 0) return bacDetail === 'Other';

    return reasons.some(r => r.description === bacDetail && r.requiresNotes);
}
